import {POSTAL_SERVICE_PAGE_LOADED, SLQ_POSTAL_SERVICE_LOAD, SLQ_POSTAL_SERVICE_UNLOAD} from "../constants/actionTypes";

export default (state = {}, action) => {
    switch (action.type) {
        case SLQ_POSTAL_SERVICE_LOAD:
            return {
                ...state,
                slqPostalServices: action.payload,
            };
        case SLQ_POSTAL_SERVICE_UNLOAD:
            return {
                ...state,
                slqPostalServices: { content: [], number: 0, size: 10, totalElements: 0 },
            }
        default:
            return state;
    }
}